import React from 'react';
import { ReactComponent as Logo } from '../../logo.svg';
import { useV2Translation } from '../i18n';
import { MenuIcon, SearchIcon } from './icons';
import { cx, FOCUS_RING } from './styles';

/**
 * `< lg` only. Hamburger → logo+wordmark → palette trigger.
 *
 * The current page title is deliberately NOT repeated here: `PageHeader` shows
 * it 8px below, and above `lg` there is no top bar at all — removing that
 * redundant 72px header is most of this revamp's perceived-density win.
 */
export const MobileTopBar: React.FC<{
  onMenuClick: () => void;
  onSearchClick: () => void;
  menuOpen: boolean;
  /** id of the drawer, for `aria-controls`. */
  drawerId: string;
}> = ({ onMenuClick, onSearchClick, menuOpen, drawerId }) => {
  const { t } = useV2Translation();

  return (
    /* Stickiness and the admin-banner offset are owned by AppShell's wrapper. */
    <div className="flex h-14 items-center justify-between border-b border-white/10 bg-[#0a0a0a]/85 px-3 backdrop-blur-md lg:hidden">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label={t(menuOpen ? 'app.navigation.closeMenu' : 'app.navigation.openMenu')}
        aria-expanded={menuOpen}
        aria-controls={drawerId}
        className={cx(
          'flex h-11 w-11 items-center justify-center rounded-lg text-white/70 transition-colors hover:bg-white/[0.06] hover:text-white',
          FOCUS_RING,
        )}
      >
        <MenuIcon className="h-5 w-5" />
      </button>

      <div className="flex items-center gap-2">
        <Logo style={{ width: '26px', height: '26px' }} />
        <span className="text-base font-bold tracking-tight text-[#3b82f6]">FlashTools</span>
      </div>

      <button
        type="button"
        onClick={onSearchClick}
        data-tour="search"
        aria-label={t('app.navigation.commandPalette')}
        title={t('app.navigation.commandPalette')}
        className={cx(
          'flex h-11 w-11 items-center justify-center rounded-lg text-white/70 transition-colors hover:bg-white/[0.06] hover:text-white',
          FOCUS_RING,
        )}
      >
        <SearchIcon className="h-5 w-5" />
      </button>
    </div>
  );
};
